// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["node_modules_normalize_css_normalize_css-styles_index_scss"], () => (__webpack_require__("./scripts/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
